/**
 * @flow
 * Created by neo on 02.06.17.
 */

import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {Collapse, Row, Col, Card, CardBody, CardHeader} from 'reactstrap';
import BookingRequest from '../../Store/Booking/BookingRequest';

type Props = {
  booking: BookingRequest
};

@observer
export default class FlightDetails extends Component {

  state: {
    collapse: boolean
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      collapse: false
    };
  }

  toggleCollapse = () => {
    this.setState({ collapse: !this.state.collapse });
  };

  render() {
    return (
      <div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Booking/FlightOffer/FlightDetails.js